import React from "react";
import './warehousenewassortmentcreation.css';
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import {
  TextField,
  Button,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  MenuItem,
  Paper,
  Divider,
  Chip,
  CircularProgress,
  Alert,
  List,
  ListItem,
  ListItemText,
  InputAdornment
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import SearchIcon from '@mui/icons-material/Search';
import removeIcon from "../../../../assests/awaitingIcon.svg"

const WarehouseAssortmentCloneComponent = ({
  startDate,
  setStartDate,
  mvIdInput,
  handleMvIdInputChange,
  selectedMvIds,
  handleAddMvId,
  handleDeleteMvId,
  filteredMvList,
  showMvIdDropdown,
  setShowMvIdDropdown,
  handleCreateNewAssortment,
  openUploadModal,
  handleOpenUploadModal,
  handleCloseUploadModal,
  mvIdsInput,
  setMvIdsInput,
  isVerified,
  handleCheckMvIds,
  handleContinue,
  activeTab,
  setActiveTab,
  categories,
  handleBulkMvIdsPaste,
  handleResetVerification,
  verifiedMvIds = [],
  invalidMvIds = [],
  handleRemoveInvalidMvId,
  duplicateMvIds = [],
  alreadySelectedMvIds = [],
  assortmentDetails,
  ruleFailures,
  failureModalOpen,
  setFailureModalOpen,
  successModalOpen,
  setSuccessModalOpen,
  newAssortmentId,
  showRuleFailurePopup,
  setShowRuleFailurePopup,
  ruleFailureData,
  lastUpdatedTime,
  showSuccessPopup,
  successData,
  handleCloseSuccessPopup,
  getReferenceName,
  setVerifiedMvIds,
  loading,
  searchLoading // New prop
}) => {
  const navigate = useNavigate();
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);
  const [itemToDelete, setItemToDelete] = React.useState(null);

  return (
    <div className="new-assortment-creation-container">
      <Sidebar />

      <div className="new-assortment-content-wrapper">
        <div className="new-assortment-header-section">
          <div>
            <button
              className="new-assortment-back-button"
              onClick={() => navigate(-1)}
            >
              ←
            </button>
            <h1 className="new-assortment-main-title">Create A Clone Assortment</h1>
          </div>
          <div>
            <Button
              variant="contained"
              className="new-assortment-bulk-upload-button"
              onClick={handleOpenUploadModal}
              startIcon={<CloudUploadIcon />}
            >
              Bulk Upload
            </Button>
          </div>
        </div>

        <div className="new-assortment-main-content-container">
          <div className="new-assortment-split-container">
            <div className="new-assortment-form-section">
              <section className="new-assortment-date-section">
                <Typography variant="h6" className="new-assortment-section-title">
                  Select Start Date
                </Typography>
                <div className="new-assortment-date-input-wrapper">
                  <TextField
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="new-assortment-date-picker"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      min: new Date(new Date().setDate(new Date().getDate() + 1))
                        .toISOString()
                        .split('T')[0]
                    }}
                    fullWidth
                    variant="outlined"
                    size="small"
                  />
                </div>
              </section>

              <section className="new-assortment-addmvid-section">
                <Typography variant="h6" className="new-assortment-section-title">
                  Add MV ID
                </Typography>
                <div className="new-assortment-input-container">
                  <div className="new-assortment-search-wrapper">
                    <TextField
                      value={mvIdInput}
                      onChange={handleMvIdInputChange}
                      className="new-assortment-mvid-input"
                      fullWidth
                      variant="outlined"
                      size="small"
                      placeholder="Search MV ID..."
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon fontSize="small" />
                          </InputAdornment>
                        ),
                        endAdornment: searchLoading && (
                          <InputAdornment position="end">
                            <CircularProgress size={20} />
                          </InputAdornment>
                        )
                      }}
                    />
                    {showMvIdDropdown && filteredMvList.length > 0 && (
                      <Paper className="new-assortment-dropdown">
                        {filteredMvList.map((mv) => (
                          <MenuItem
                            key={mv.id}
                            onClick={() => handleAddMvId(mv)}
                            className="new-assortment-dropdown-item"
                          >
                            <div className="mv-item-container">
                              <span className="mv-id">{mv.id}</span>
                              <span className="mv-name">
                                {mv.variant_name || mv.name} 
                                {mv.mrp ? ` (Rs.${mv.mrp})` : ''}
                              </span>
                              <Button
                                variant="contained"
                                size="small"
                                className="mv-add-button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleAddMvId(mv);
                                }}
                              >
                                Add
                              </Button>
                            </div>
                          </MenuItem>
                        ))}
                      </Paper>
                    )}
                    {showMvIdDropdown && filteredMvList.length === 0 && !searchLoading && (
                      <Paper className="new-assortment-dropdown">
                        <div className="warehouse-rule-dropdown-no-results">
                          {mvIdInput ? "No results found" : "Start typing to search"}
                        </div>
                      </Paper>
                    )}
                  </div>
                </div>
              </section>
            </div>

            <div style={{ width: "400px" }}>
              <div className="toggle-button-container">
                <button
                  className={`toggle-option ${activeTab === 'list' ? 'active' : ''}`}
                  onClick={() => setActiveTab('list')}
                >
                  List
                </button>
                <button
                  className={`toggle-option ${activeTab === 'categories' ? 'active' : ''}`}
                  onClick={() => setActiveTab('categories')}
                >
                  Categories
                </button>
              </div>
              <div className="new-assortment-selected-section">
                <div className="new-assortment-selected-header">
                  <Typography variant="h6" className="new-assortment-section-title">
                    Selected MVID's <br />
                    <span style={{ fontSize: "14px", fontWeight: 400, margin: "0px" }}>
                      From Assortment Id: {assortmentDetails && assortmentDetails.id}
                    </span>
                  </Typography>

                  <div className="new-assortment-cart-indicator">
                    <ShoppingCartIcon />
                    <span className="new-assortment-cart-count">
                      {selectedMvIds.length}
                    </span>
                  </div>
                </div>

                <div className="new-assortment-selected-mvids">
                  {selectedMvIds.length > 0 ? (
                    activeTab === 'list' ? (
                      <div className="new-assortment-mvid-list-container">
                        {selectedMvIds.map((mv, index) => (
                          <div
                            key={`${mv.id}-${index}`}
                            className="selected-mv-item"
                            style={{ position: 'relative' }}
                          >
                            <div
                              style={{
                                position: 'absolute',
                                left: '-30px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                minWidth: '24px',
                                fontWeight: '500',
                                color: '#333',
                                fontSize: '14px',
                                textAlign: 'right',
                                color: "#14AE78",
                                border: "1px solid  #14AE78",
                                borderRadius: "50%",
                                textAlign: "center"
                              }}
                            >
                              {index + 1 < 10 ? `0${index + 1}` : index + 1}
                            </div>

                            <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
                              {mv.image_id && (
                                <img
                                  alt="Product"
                                  src={`https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/${mv.image_id}`}
                                  style={{
                                    height: "56px",
                                    width: "57px",
                                    borderRadius: "4px",
                                    objectFit: "cover"
                                  }}
                                />
                              )}
                              <div className="mv-item-info">
                                <Typography variant="body1" className="mv-item-name">
                                  <span>{mv.variant_name}</span>
                                </Typography>
                                <Typography variant="body1" className="mv-item-id">
                                  <span>MVID: {mv.id}</span>
                                </Typography>
                                <Typography variant="body2" className="mv-item-price">
                                  ₹ {mv.mrp || '0'}
                                </Typography>
                              </div>
                            </div>
                            <IconButton
                              size="small"
                              className="mv-delete-button"
                              onClick={(e) => {
                                e.stopPropagation();
                                setItemToDelete(mv);
                                setDeleteConfirmationOpen(true);
                              }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="category-list-container">
                        {categories.length > 0 ? (
                          categories.map((category, index) => (
                            <div key={index} style={{ marginBottom: '16px', padding: '8px', borderBottom: '1px solid #eee' }}>
                              <Typography variant="subtitle1" className="category-name" style={{ fontWeight: 'bold' }}>
                                {category.name} ({category.count})
                              </Typography>
                            </div>
                          ))
                        ) : (
                          <Typography variant="body2" className="no-categories-message" style={{ padding: '16px', textAlign: 'center' }}>
                            No categories available
                          </Typography>
                        )}
                      </div>
                    )
                  ) : (
                    <Typography variant="body2" className="new-assortment-no-items">
                      No Items Selected Yet
                    </Typography>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="new-assortment-action-buttons-container">
            <Button
              variant="outlined"
              className="new-assortment-cancel-button"
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="new-assortment-create-button"
              disabled={!startDate || selectedMvIds.length === 0 || loading}
              onClick={handleCreateNewAssortment}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "Save"}
            </Button>
          </div>
        </div>
      </div>

      <Dialog
        open={deleteConfirmationOpen}
        onClose={() => setDeleteConfirmationOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogContent>
          <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" textAlign="center">
            <img src={removeIcon} alt="Remove Icon" style={{ width: "50px", marginBottom: "16px" }} />
            <Typography variant="body1" gutterBottom color="#E02D3C">
              Are you sure you want to remove this item?
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2, justifyContent: "space-evenly" }}>
          <Button onClick={() => setDeleteConfirmationOpen(false)} color="primary" variant="outlined">
            No
          </Button>
          <Button
            onClick={() => {
              handleDeleteMvId(itemToDelete);
              setDeleteConfirmationOpen(false);
            }}
            style={{ backgroundColor: "#14AE78" }}
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Success Modal */}
      <Dialog
        open={showSuccessPopup}
        onClose={handleCloseSuccessPopup}
        maxWidth="xs"
        fullWidth
      >
        <DialogContent>
          <Box display="flex" flexDirection="column" alignItems="center" p={3}>
            <CheckCircleIcon color="success" style={{ fontSize: 60, marginBottom: 16 }} />
            <Typography variant="h6" align="center" gutterBottom>
              You Successfully Created Assortment (Id-{successData.id}) for {successData.name}
            </Typography>

            <Button
              fullWidth
              variant="contained"
              color="success"
              onClick={handleCloseSuccessPopup}
              style={{ marginTop: 20, minWidth: 120 }}
            >
              OK
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Rule Failure Modal */}
      <Dialog
        open={showRuleFailurePopup}
        onClose={() => setShowRuleFailurePopup(false)}
        maxWidth="sm"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '12px',
            padding: '16px',
            maxHeight: '80vh'
          }
        }}
      >
        <DialogTitle sx={{ p: 0 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex" alignItems="center" gap={1}>
              <ErrorIcon color="error" />
              <Typography variant="h6" fontWeight={600}>
                {ruleFailureData.length} Rule Failure{ruleFailureData.length !== 1 ? 's' : ''}
              </Typography>
            </Box>
            <IconButton
              onClick={() => setShowRuleFailurePopup(false)}
              size="small"
              sx={{ color: 'text.secondary' }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </DialogTitle>

        <Typography variant="body2" color="textSecondary" mt={1}>
          Last updated at {lastUpdatedTime}
        </Typography>

        <Divider sx={{ my: 2 }} />

        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ maxHeight: '60vh', overflowY: 'auto', pr: 1 }}>
            {ruleFailureData.map((failure, index) => (
              <Box key={index} mb={3} sx={{
                borderLeft: '4px solid #ff6b6b',
                pl: 2,
                py: 1,
                backgroundColor: '#fffbfb'
              }}>
                <Box display="flex" alignItems="flex-start" gap={1}>
                  <Typography variant="subtitle1" fontWeight={500} sx={{ flexShrink: 0 }}>
                    {index + 1}.
                  </Typography>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle1" fontWeight={500} sx={{ textTransform: 'capitalize' }}>
                      {failure.failureType.replace(/_/g, ' ')}
                    </Typography>

                    {failure.failedItems?.ids && failure.failedItems.ids.length > 0 && (
                      <Box sx={{ mt: 1.5 }}>
                        <Typography variant="body2" fontWeight={500} sx={{ mb: 1 }}>
                          Failed MV IDs ({failure.failedItems.ids.length}):
                        </Typography>
                        <Box sx={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: 1,
                          mt: 1
                        }}>
                          {failure.failedItems.ids.map((id, idIndex) => (
                            <Chip
                              key={idIndex}
                              label={`MVID-${id}`}
                              size="small"
                              sx={{
                                backgroundColor: '#ffeeee',
                                color: '#d32f2f',
                                borderRadius: '4px',
                                fontWeight: 500,
                                border: '1px solid #ffcdd2'
                              }}
                            />
                          ))}
                        </Box>
                      </Box>
                    )}

                    {failure.failedItems?.message && (
                      <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                        {failure.failedItems.message}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setShowRuleFailurePopup(false)}
            color="primary"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bulk Upload Modal */}
      <Dialog
        open={openUploadModal}
        onClose={handleCloseUploadModal}
        maxWidth="sm"
        fullWidth
        className="new-assortment-upload-modal"
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Paste or Enter MV IDs</Typography>
            <IconButton onClick={handleCloseUploadModal}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Paste MV IDs separated by commas
          </Typography>

          {!isVerified ? (
            <>
              <TextField
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                placeholder="Enter MV IDs separated by commas..."
                value={mvIdsInput}
                onChange={(e) => {
                  const input = e.target.value.replace(/[^0-9,]/g, '');
                  const cleanedInput = input.split(',')
                    .map(id => id.replace(/^0+/, ''))
                    .join(',');
                  setMvIdsInput(cleanedInput);
                }}
                onPaste={handleBulkMvIdsPaste}
                className="mv-ids-textarea"
              />

              <Box mt={2} display="flex" justifyContent="flex-end">
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleCheckMvIds}
                  disabled={!mvIdsInput.trim()}
                  sx={{
                    '&:disabled': {
                      backgroundColor: '#f5f5f5',
                      color: '#bdbdbd',
                      cursor: 'not-allowed'
                    }
                  }}
                >
                  Verify MV IDs
                </Button>
              </Box>
            </>
          ) : (
            <Box mt={2}>
              {verifiedMvIds.length > 0 && (
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    p: 1,
                    borderRadius: 1,
                    border: "1px solid #14AE78",
                    mb: 2
                  }}
                >
                  <Typography variant="body2" color="success.main" sx={{ width: '100%' }}>
                    Valid MV IDs ({verifiedMvIds.length})
                  </Typography>
                  {verifiedMvIds.map((mv, index) => (
                    <Chip
                      key={`valid-${index}`}
                      label={mv.id}
                      sx={{
                        backgroundColor: "#14AE7833",
                        borderRadius: 1,
                        border: "1px solid #14AE78",
                        '& .MuiChip-deleteIcon': {
                          color: "#14AE78"
                        }
                      }}
                      onDelete={() => {
                        const updatedVerified = verifiedMvIds.filter(v => v.id !== mv.id);
                        setVerifiedMvIds(updatedVerified);
                        setMvIdsInput(mvIdsInput.split(',')
                          .filter(id => id !== mv.id.toString())
                          .join(',')
                        );
                      }}
                      deleteIcon={<CloseIcon fontSize="small" />}
                    />
                  ))}
                </Box>
              )}

              {invalidMvIds.length > 0 && (
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    p: 1,
                    borderRadius: 1,
                    border: "1px solid #DB0F0F",
                    mb: 2
                  }}
                >
                  <Typography variant="body2" color="error" sx={{ width: '100%' }}>
                    Invalid MV IDs ({invalidMvIds.length})
                  </Typography>
                  {invalidMvIds.map((mvId, index) => {
                    const isDuplicate = duplicateMvIds.includes(mvId);
                    const isAlreadySelected = alreadySelectedMvIds.includes(mvId);

                    return (
                      <Chip
                        key={`invalid-${index}`}
                        label={mvId}
                        sx={{
                          backgroundColor: isDuplicate ? "#FF980026" :
                            isAlreadySelected ? "#FFC10726" : "#DB0F0F26",
                          borderRadius: 1,
                          border: isDuplicate ? "1px solid #FF9800" :
                            isAlreadySelected ? "1px solid #FFC107" : "1px solid #DB0F0F"
                        }}
                        onDelete={() => handleRemoveInvalidMvId(mvId)}
                        deleteIcon={<CloseIcon fontSize="small" />}
                      />
                    );
                  })}
                </Box>
              )}

              <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
                <Button
                  variant="outlined"
                  onClick={handleResetVerification}
                  className="cancel-button"
                >
                  Reset
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleContinue}
                  disabled={verifiedMvIds.length === 0}
                  sx={{
                    '&:disabled': {
                      backgroundColor: '#f5f5f5',
                      color: '#bdbdbd',
                      cursor: 'not-allowed'
                    }
                  }}
                >
                  Continue
                </Button>
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default WarehouseAssortmentCloneComponent;